import { LANGUAGE } from "../../actions";
 

export const setLanguage = (lang) => {
    return async dispatch => {
        await dispatch({type: LANGUAGE, payload: lang});
    };
};